import React from 'react';

import {View, TouchableOpacity} from 'react-native';
import {useNavigation} from '@react-navigation/native';
import {NotificationResponsePayload} from '../../../../shared/models/api';

import {images} from '../../../../assets/icons';
import {DeviceSize, useDeviceSize} from '../../../../shared/theme/helpers';
import {Link} from '../../../../shared/components/link';
import {Screens} from '../../../../shared/routing';
import {Text} from '../../../../shared/components/text';
import {Table} from '../../../../shared/components/table';
import {Column} from '../../../../shared/components/table/model';
import {datePipe} from '../../../../shared/pipes';
import {dateFormats} from '../../../../shared/constants/date';
import NotificationsMobileView from '../../../notifications/components/list/mobile';
import {LoadableContent} from '../../../../shared/components/loadableContent';
import {NotificationStatus} from '../../../../shared/models/profile/notification';
import {useTheme} from '../../../../shared/theme';

import {Props} from './model';
import GetStyles from './styles';

export default ({notifications, count, hideBottomLineWhenAllShown: hideBottomLineWhenAllShown}: Props) => {
  const deviceSize = useDeviceSize();
  const nav = useNavigation();
  const theme = useTheme();
  const styles = GetStyles(count);

  const columns: Column<NotificationResponsePayload>[] = [
    {
      title: '',
      titleTestID: 'notification-read-status-header-id',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <View style={styles.icon}>
            {isRead ? (
              <images.NotCheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
            ) : (
              <images.CheckRound width={styles.icon.width} height={styles.icon.height} color={styles.icon.color} />
            )}
          </View>
        );
      },
      field: 'statusId',
      headStyles: {
        colHeadStyle: styles.colStatus,
      },
      styles: {
        colBodyStyle: styles.colStatus,
      },
    },
    {
      title: '',
      titleTestID: 'notification-topic-link-header-id',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <Link
            testID={`notification-topic-link-${notification.id}-id`}
            textStyle={isRead ? styles.colBodyMessageText : styles.colBodyMessageTextNotRead}
            navigate={nav.navigate}
            screenParams={{id: notification?.id || '', tab: 'notifications'}}
            screen={Screens.Main}>
            {notification.topic}
          </Link>
        );
      },
      field: 'topic',
      headStyles: {
        colHeadStyle: styles.colText,
      },
      styles: {
        colBodyStyle: styles.colText,
      },
    },
    {
      title: 'Дата',
      titleTestID: 'notification-topic-link-header-id',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <Text
            testID={`notification-topic-date-${notification.id}-id`}
            style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>
            {datePipe(notification.dateTime)}
          </Text>
        );
      },
      field: 'dateTime',
      headStyles: {
        colHeadStyle: styles.colDate,
      },
      styles: {
        colBodyStyle: styles.colDate,
      },
    },
    {
      title: 'Время',
      titleTestID: 'notification-item-time-header-id',
      render: (notification) => {
        const isRead = notification.statusId === NotificationStatus.Read;
        return (
          <Text
            testID={`notification-topic-date-second-${notification.id}-id`}
            style={isRead ? styles.colBodyText : styles.colBodyTextNotRead}>
            {datePipe(notification?.dateTime, dateFormats.time)}
          </Text>
        );
      },
      field: 'dateTime',
      headStyles: {
        colHeadStyle: styles.colTime,
      },
      styles: {
        colBodyStyle: styles.colTime,
      },
    },
  ];

  const ButtonMore = () => {
    return (
      <View style={styles.linkMoreContainer}>
        <TouchableOpacity
          testID='notification-show-all-id'
          onPress={() =>
            nav.navigate(deviceSize === DeviceSize.desktop ? Screens.Notifications : Screens.NotificationsMenu)
          }
          style={styles.linkMore}>
          <Text testID='notification-show-all-text-id' style={styles.linkMoreText}>
            Показать все
          </Text>
          <images.Right color={theme.color.primaryColor} height={14} width={14} />
        </TouchableOpacity>
      </View>
    );
  };

  return (
    <LoadableContent loading={!notifications}>
      {count ? (
        <View style={styles.mainContainer}>
          <Text
            testID='last-notifications-label-id'
            style={deviceSize === DeviceSize.desktop ? styles.textContainer : styles.textContainerMobile}>
            Последние уведомления
          </Text>
          <View>
            {deviceSize === DeviceSize.desktop ? (
              <Table
                data={notifications}
                columns={columns}
                hideBottomLine={hideBottomLineWhenAllShown && count <= 3}
                testIdPrefix='notification-row'
              />
            ) : (
              <NotificationsMobileView
                baseItemScreen={Screens.MainNotificationsItem}
                notifications={notifications}
                hideBottomLine={hideBottomLineWhenAllShown && count <= 3}
              />
            )}
            {count > 3 && <ButtonMore />}
          </View>
        </View>
      ) : null}
    </LoadableContent>
  );
};
